import React from 'react';
import HeaderTargetPair from './HeaderTargetPair';
import './index.css';


export default class HeaderGroup extends React.Component{
    
    render(){

        const options = this.props.options.map(
            opt => {
                return <option value={opt}>{opt}</option>
            }
        )

        var headerTargetItems = [];
        
        for(var i = 1; i<=this.props.count; i++){
            var items = this.props.headers.map(
                header => {
                    return (
                    <div className='header-target-item'>
                        <p className='headerName'>{this.props.header + i + header}</p>
                        <select className='headerTargetValue'>
                            {options}
                        </select>
                    </div>
                )
                }
            )
            
            headerTargetItems.push(items)

        var additional_items = [];

        for (const additional in this.props.additionals) {

            const options = this.props.additionals[additional].map(element => {return <option value={element}>{element}</option>})

            const new_item = (
            <div className='header-target-item'>
                <p className='headerName'>{this.props.header + i + additional}</p>
                <select className='headerTargetValue'>
                    {options}
                </select>
            </div>)
            additional_items.push(new_item)  
          }

          headerTargetItems.push(additional_items)

        }

        
        
        
        

        return(

            <div className='target-group'>

                <HeaderTargetPair headerKey={this.props.header + "Count"} onValChange={this.props.onValChange}/>

                <div id={`${this.props.header}-group-items`} className="group-items">

                    {headerTargetItems}

                </div>

            </div>

        );
    }
}